import { XepptClient } from '@xeppt/xeppt-sdk';

const BASE = '/admin/aml/settings';

export type TAmlSettingsSource = 'db' | 'env';

export type TAmlSettings = {
    base_url: string;
    webhook_url: string;
    api_key_set: boolean;
    api_key_last4: string;
    api_key_rotated_at: string | null;
    api_key_prev_set: boolean;
    webhook_secret_set: boolean;
    webhook_secret_last4: string;
    webhook_secret_rotated_at: string | null;
    webhook_secret_prev_set: boolean;
    source: {
        base_url: TAmlSettingsSource;
        api_key: TAmlSettingsSource;
        webhook_url: TAmlSettingsSource;
        webhook_secret: TAmlSettingsSource;
    };
    updated_at: string | null;
    updated_by: string | null;
};

export type TAmlConnectionTestResult = {
    ok: boolean;
    detail: string;
};

export type TAmlSettingsAuditItem = {
    action: string;
    field: string;
    actor: string;
    at: string;
};

export type TAmlSettingsAudit = {
    items: TAmlSettingsAuditItem[];
    total: number;
};

export class AmlSettingsService {
    constructor(private readonly client: XepptClient) {}

    getSettings(): Promise<TAmlSettings> {
        return this.client.request({ method: 'GET', url: BASE });
    }

    updateSettings(payload: { base_url: string; webhook_url: string }): Promise<void> {
        return this.client.request({ method: 'PUT', url: BASE, body: payload });
    }

    rotateApiKey(api_key: string): Promise<void> {
        return this.client.request({
            method: 'POST',
            url: `${BASE}/api-key/rotate`,
            body: { api_key }
        });
    }

    rotateWebhookSecret(webhook_secret: string): Promise<void> {
        return this.client.request({
            method: 'POST',
            url: `${BASE}/webhook-secret/rotate`,
            body: { webhook_secret }
        });
    }

    testConnection(): Promise<TAmlConnectionTestResult> {
        return this.client.request({ method: 'POST', url: `${BASE}/test-connection` });
    }

    testWebhook(): Promise<TAmlConnectionTestResult> {
        return this.client.request({ method: 'POST', url: `${BASE}/test-webhook` });
    }

    getAudit(limit: number, offset: number): Promise<TAmlSettingsAudit> {
        return this.client.request({
            method: 'GET',
            url: `${BASE}/audit`,
            query: { limit, offset }
        });
    }
}
